import { API_URL } from '../../../app-config/constants';
import { get } from '../request';

getById.operation = 'READ';
getById.byId = true;
export function getById(id) {
    return get(`${API_URL}/feedback/participant/mini/${id}`);
}
